import { useReports } from '@sail/observability';
import { useUpdatedRef } from '@sail/react';
import { useCallback, useContext, useMemo } from 'react';
import HrefContext, { defaultSetHref } from '../../internal/contexts/HrefContext';
/**
 * @see https://sail.stripe.me/apis/navigation/useHref
 */ export default function useHref() {
    const [href, setHref] = useContext(HrefContext);
    const { error } = useReports();
    const hrefRef = useUpdatedRef(href);
    const setHrefRef = useUpdatedRef(setHref);
    if (setHref === defaultSetHref) {
        error('Setters for `href` are not configuring, navigating using `@sail/navigation` will not work.');
    }
    const setDeduplicatedHref = useCallback((newHref, replace)=>{
        const resolvedHref = typeof newHref === 'function' ? newHref(hrefRef.current) : newHref;
        if (hrefRef.current !== resolvedHref) {
            setHrefRef.current(resolvedHref, !!replace);
        }
    }, [
        setHrefRef,
        hrefRef
    ]);
    return useMemo(()=>[
            href,
            setDeduplicatedHref
        ], [
        href,
        setDeduplicatedHref
    ]);
}

//# sourceMappingURL=useHref.js.map